module.exports = __webpack_public_path__ + "img/search-calendar.bc1e3bf8.svg";